import React, { useRef, useEffect, useState } from 'react';
import {
    CFormTextarea, CCard, CCardBody, CButton, CModal, CModalHeader, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CBadge,
    CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput,
    CSpinner
} from '@coreui/react';
import ImagingInformation from "../../services/general/ImagingAPI.api.js";
import HighlightedText from './../../components/shared/HighlightedText';
import CIcon from '@coreui/icons-react';
import { cilPencil, cilTrash } from '@coreui/icons';
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import Carder from '../../components/shared/Carder.jsx';
import PatientImagingsCRUD from '../../services/general/patientImagingData.js';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config.js';
import Graytextarea from '../../components/Graytextarea.jsx';
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx';
import moment from 'moment';
import HighlightedTextImaging from './HighlghtedImaging.jsx';
import Highlighter from 'react-highlight-words';
import { X } from 'lucide-react';

const ProvuderPatientImaging = ({ patientID, loading, setLoading, imagingList, saveTreatsShell, render, setRender, imagingTypeList, setImagingList, diagnosis, GetPatientImagings, updatePatientDiagnosis, noteStructureRef, showComment, setShowComment, addDiagnosisIdsToNote }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [date, setDate] = useState('');
    const [imagingType, setImagingType] = useState('');
    const [selectedImagingType, setSelectedImagingType] = useState(null);
    const [impression, setImpression] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [possibleDiagnosis, setPossibleDiagnosis] = useState([]);
    const [diagnosisModalVisible, setDiagnosisModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const detectedKeywordsRef = useRef(new Set());
    const [editImagingId, setEditImagingId] = useState(null);
    const [deleteVisibleId, setDeleteVisibleId] = useState(null)
    const [comment, setComment] = useState(null)
    const [imagingNoteIdEdit, setImagingNoteIdEdit] = useState([])

    useEffect(() => {
        setDate(getFormattedDate());
    }, [patientID]);

    const getFormattedDate = (dateStr) => {
        const today = dateStr ? new Date(dateStr) : new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };

    const handleSaveImaging = async () => {
        filterDiagnosis();
    }

    const saveImaging = async () => {
        if (!date || !selectedImagingType || !impression) {
            toast.error("Please fill the fields with information", toastConfig)
            return;
        }
        setIsLoading(true)
        try {
            try {
                let diagnosisData = await GetDiagnosisData();
                let tempData = JSON.parse(diagnosisData.d)?.Data;

                const concatedAllImpression = impression;
                const sanitizedImpression = concatedAllImpression.replace(/[^a-zA-Z0-9\s]/g, '');

                const inputKeywords = sanitizedImpression
                    .toLowerCase()
                    .split(/\s+/)
                    .filter((keyword) => keyword.trim() !== '');

                const matchedDiagnoses = tempData.filter((diag) => {
                    const diagnosisKeywords = (diag?.Keywords || '').split(',').map((k) => k.trim().toLowerCase());
                    let match = true;
                    diagnosisKeywords.find((diagnosisKeyword) => {
                        match = true;
                        const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/);
                        if (diagnosisKeywordParts.length > 1) {
                            let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0]);
                            if (foundIndex != -1) {
                                for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {
                                    if (inputKeywords.length < foundIndex + i) {
                                        match = false;
                                        break;
                                    }
                                    if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                                        match = false;
                                        break;
                                    }
                                }
                            } else {
                                match = false;
                            }
                        } else {
                            let foundKeyword = inputKeywords.includes(diagnosisKeyword);
                            if (!foundKeyword) {
                                match = false;
                            } else {
                                match = true;
                            }
                        }
                        if (match) return true;
                    });
                    return match;
                });

                let historyDiagnosis = {};
                matchedDiagnoses.forEach((diag) => {
                    const diagName = diag.Name.trim();
                    let existingData = noteStructureRef.current?.information?.[diagName] || [];
                    if (!existingData.includes(`Imaging(${selectedImagingType.Name})`)) {
                        historyDiagnosis[diagName] = [...existingData, `Imaging(${selectedImagingType.Name})`];
                    }
                });

                if (Object.keys(historyDiagnosis).length > 0) {
                    noteStructureRef.current = {
                        ...noteStructureRef.current,
                        information: {
                            ...noteStructureRef.current?.information,
                            ...historyDiagnosis,
                        },
                    };
                }
            } catch (err) {
                console.log('Error updating imaging information', err);
            }

            if (editImagingId !== null) {
                const filteredKeywords = selectedImagingType.Keywords
                    .map(item => item.keyword)
                    .filter(item => item !== '')
                    .flatMap(item => item.split(','))
                    .map(keyword => keyword.trim());

                const uniqueKeywords = Array.from(new Set(filteredKeywords));

                const newImagingWhichUpdated = {
                    name: selectedImagingType.Name,
                    imagingType,
                    impression: impression,
                    comment: comment,
                    // keywords: uniqueKeywords,
                    priority: selectedImagingType.Priority,
                }

                await PatientImagingsCRUD('UPDATE', patientID.toString(), JSON.stringify(newImagingWhichUpdated), getFormattedDate().toString(), editImagingId.toString())

                setDate(getFormattedDate());
                setImagingType('');
                setImpression('');
                setComment('');
                setSelectedImagingType(null)
                setEditImagingId(null)
                setModalVisible(false);
                setDiagnosisModalVisible(false)
                setRender(p => !p)
                toast.success("Successfully Updated", toastConfig)
            }
            else {
                const filteredKeywords = selectedImagingType.Keywords
                    .map(item => item.keyword)
                    .filter(item => item !== '')
                    .flatMap(item => item.split(','))
                    .map(keyword => keyword.trim());

                const uniqueKeywords = Array.from(new Set(filteredKeywords));

                const newImaging = {
                    name: selectedImagingType.Name,
                    imagingType,
                    impression: impression,
                    comment: comment,
                    // keywords: uniqueKeywords,
                    priority: selectedImagingType.Priority,
                }

                await PatientImagingsCRUD('INSERT', patientID.toString(), JSON.stringify(newImaging), getFormattedDate(date).toString())
                const imagingListWithNew = await GetPatientImagings();
                console.log(imagingListWithNew, 'imagingListWithNew');

                if (imagingListWithNew.length > 0) {
                    const lastImaging = imagingListWithNew[imagingListWithNew.length - 1];

                    noteStructureRef.current = {
                        ...noteStructureRef.current,
                        metadata: {
                            ...noteStructureRef.current.metadata,
                            imagingIds: [
                                ...(noteStructureRef.current.metadata?.imagingIds || []),
                                lastImaging?.id
                            ]
                        }
                    };

                    setImagingNoteIdEdit((prev) => [...prev, lastImaging?.id]);
                    saveTreatsShell(false)
                    toast.success('Successfully Save', toastConfig)
                }


                setDate(getFormattedDate());
                setImagingType('');
                setImpression('');
                setComment('');
                setSelectedImagingType(null)
                setModalVisible(false);
                setDiagnosisModalVisible(false)
                setRender(p => !p)
            }
        } catch (error) {
            console.log(error)
        }
        finally {
            setIsLoading(false)
        }
    }



    const handleDeleteImagingPatient = async (id) => {
        await PatientImagingsCRUD('DELETE', patientID.toString(), "", "", deleteVisibleId?.toString())
        await GetPatientImagings()
        setDeleteVisibleId(null)
    }

    const handleSelectImaging = (e) => {
        const selectedType = imagingTypeList.find(i => i.ID === parseInt(e.target.value));
        setImagingType(e.target.value || '');
        setSelectedImagingType(selectedType || null);
    };

    const filterDiagnosis = async () => {
        if (!date || !selectedImagingType || !impression) {
            toast.error("Please fill the fields with information", toastConfig)
            return;
        }
        const sanitizedImpression = impression.replace(/[^a-zA-Z0-9\s]/g, '');

        // Split the sanitized impression into keywords
        const inputKeywords = sanitizedImpression.toLowerCase().split(/\s+/).filter(keyword => keyword.trim() !== '');
        detectedKeywordsRef.current.clear(); // Clear previous keywords


        let diagnosisData = await GetDiagnosisData();
        let tempData = JSON.parse(diagnosisData.d)?.Data;

        const possibleDiagnosis = tempData.filter(diagnosis => {
            const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map(keyword => keyword.trim().toLowerCase());
            let match = true
            diagnosisKeywords.find((diagnosisKeyword) => {
                match = true

                const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/);
                if (diagnosisKeywordParts.length > 1) {
                    let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0]);

                    if (foundIndex != -1) {
                        for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {

                            if (inputKeywords.length < foundIndex + i) {
                                match = false
                                break
                            }
                            if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {

                                match = false
                                break
                            }

                        }
                    } else {
                        match = false

                    }

                } else {
                    let foundKeyword = inputKeywords.includes(diagnosisKeyword);
                    if (!foundKeyword) {
                        match = false
                    } else {
                        match = true
                    }
                }
                if (match) {
                    return true

                }
            })
            if (match) {
                diagnosisKeywords.forEach(keyword => detectedKeywordsRef.current.add(keyword));
            }
            return match
        });
        let result = possibleDiagnosis.filter(item => !diagnosis.includes(item.Name.trim()))
        setPossibleDiagnosis(result);
        if (result.length > 0) {
            setDiagnosisModalVisible(true);
        } else {
            saveImaging()
        }
    };

    const formatDateForDisplay = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${month}-${day}-${year}`;
    };
    const handleRemoveDiagnosis = (indexToRemove) => {
        setPossibleDiagnosis(prevDiagnosis => prevDiagnosis.filter((_, index) => index !== indexToRemove));
    };

    const addDiagnosis = () => {
        console.log("new imaging", selectedImagingType.Name, possibleDiagnosis)
        let newDiagnosis = possibleDiagnosis.map(obj => {
            return obj.Name.trim();
        });
        let historyDiagnosis = newDiagnosis.reduce((acc, item) => {

            let existingData = noteStructureRef.current?.information?.[item] || [];

            if (!existingData.includes(`Imaging(${selectedImagingType.Name})`)) {
                acc[item] = [...existingData, `Imaging(${selectedImagingType.Name})`];
            } else {
                acc[item] = existingData;
            }


            return acc;
        }, {});

        noteStructureRef.current = {
            ...noteStructureRef.current,
            information: {
                ...noteStructureRef.current.information,
                ...historyDiagnosis
            }
        };

        newDiagnosis = newDiagnosis.join(',');
        const diagnosisIds = possibleDiagnosis.map(item => item.id)
        addDiagnosisIdsToNote(diagnosisIds)
        updatePatientDiagnosis(patientID, newDiagnosis);
        setModalVisible(false);
        saveImaging()
    };

    const handleEditPatientImaging = (imaging) => {
        setImagingType(imaging.data.imagingType);
        setImpression(imaging.data?.impression);
        setComment(imaging?.data?.comment);
        setEditImagingId(imaging.id);
        const findImagingMaster = imagingTypeList.find(i => i.Name === imaging.data?.name)
        setSelectedImagingType(findImagingMaster);
        setDate(imaging.date);
        setModalVisible(true);
    }


    const handleAddImaging = () => {
        setModalVisible(true);
    };

    useEffect(() => {
        const imagingIds = noteStructureRef.current?.metadata?.imagingIds || []
        console.log(noteStructureRef.current, 'noteStructureRef.current?.metadata?.imagingIds')
        setImagingNoteIdEdit(imagingIds)
    }, [])
    console.log(noteStructureRef.current, 'noteStructureRef.current?.metadata?.imagingIds')

    console.log(imagingNoteIdEdit, 'imagingNoteIdEdit')
    return (
      <>
        {/* delete modal */}
        <CModal visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={handleDeleteImagingPatient} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal" backdrop="static" size="lg" visible={diagnosisModalVisible} onClose={() => setDiagnosisModalVisible(false)}>
          <CModalHeader onClose={() => setDiagnosisModalVisible(false)}>
            <CModalTitle>Diagnosis Details</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="d-flex">
              <div style={{ minWidth: '50%', maxWidth: '50%', width: '50%' }} className="flex-fill me-3 text-display">
                <p style={{ whiteSpace: 'pre-line' }}></p>
                <HighlightedText text={impression} keywords={Array.from(detectedKeywordsRef.current)}></HighlightedText>
              </div>
              <div className="flex-fill">
                <h5>Detected Diagnosis</h5>
                {possibleDiagnosis.map((diagnosis, index) => (
                  <CBadge key={index} color="info" className="d-flex align-items-center gap-2 me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer', width: 'fit-content', maxWidth: '100%' }}>
                    {diagnosis.Name}
                    <X onClick={() => handleRemoveDiagnosis(index)} size={15} />
                  </CBadge>
                ))}
                <hr />
                <h5>Existing Diagnosis</h5>
                {diagnosis.map((diagnosisItem, index) => (
                  <CBadge key={index} color="primary" className="me-2 mr-1 mb-1">
                    {diagnosisItem}
                  </CBadge>
                ))}
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton variant="outline" color="primary" onClick={addDiagnosis}>
              Add Diagnosis
            </CButton>
            <CButton variant="outline" color="secondary" onClick={saveImaging}>
              Continue without adding
            </CButton>
          </CModalFooter>
        </CModal>

        {/* <CButton style={{ marginTop: "10px" }} className='stick-patient-btn' onClick={handleAddImaging} variant="outline" color="primary">
                + Add Imaging
            </CButton> */}

        <div>
          <div className="" style={{ borderRadius: '10px' }}>
            {/* <hr className="hr-text" data-content="Current Imagings" /> */}
            <h6 className="text-white d-flex justify-content-center  ">Current Imagings</h6>

            {[...imagingList]
              .filter((imgEntry) => noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
              ?.reverse()
              .map((imgEntry, index) => {
                return (
                  <div
                    // editFunc={
                    //     imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id))
                    //         ? () => handleEditPatientImaging(imgEntry)
                    //         : null
                    // }
                    // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
                    key={index}
                    style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#292828ff' }}
                    className="mt-4 overflow-hidden"
                  >
                    <CCardBody>
                      <div className="mb-3">
                        Date:{' '}
                        {new Date(imgEntry.date).toLocaleDateString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        })}
                      </div>
                      <div>
                        <div className="mb-2">
                          <strong>Imaging Type:</strong> {imgEntry.data?.name}
                        </div>
                        <div className="mb-3">
                          <strong>Impression:</strong>

                          <Highlighter
                            textToHighlight={imgEntry?.data?.impression}
                            searchWords={imgEntry?.data?.selectedText}
                            highlightStyle={{
                              backgroundColor: 'transparent',
                              color: 'orange',
                              fontWeight: 'bold',
                            }}
                          />
                        </div>
                        {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                      </div>

                      {/* <CTable>
                                <CTableHead>
                                    <CTableRow>
                                        <CTableHeaderCell>Imaging Type</CTableHeaderCell>
                                        <CTableHeaderCell>Impression</CTableHeaderCell>

                                    </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                    <CTableRow>
                                        <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
                                        <CTableDataCell style={{ width: "60%" }} className='' valign="" >
                                            <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                        </CTableDataCell>


                                    </CTableRow>
                                </CTableBody>
                            </CTable> */}
                    </CCardBody>
                  </div>
                )
              })}
          </div>
          {!loading && imagingList.length === 0 && <div className="text-center text-muted my-4">No Current Imaging Available</div>}
          
          <div className="mt-4">
            <h6 className="text-white d-flex justify-content-center  ">Old Imagings</h6>

            {[...imagingList]
              .filter((imgEntry) => !noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
              ?.reverse()
              .map((imgEntry, index) => {
                return (
                  <div
                    // editFunc={
                    //     imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id))
                    //         ? () => handleEditPatientImaging(imgEntry)
                    //         : null
                    // }
                    // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
                    key={index}
                    style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#292828ff' }}
                    className="mt-3 overflow-hidden"
                  >
                    <CCardBody>
                      <div className="mb-3">
                        Date:{' '}
                        {new Date(imgEntry.date).toLocaleDateString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        })}
                      </div>
                      <div>
                        <div className="mb-2">
                          <strong>Imaging Type:</strong> {imgEntry.data?.name}
                        </div>
                        <div className="mb-3">
                          <strong>Impression:</strong>
                          <div className="p-2">
                            <Highlighter
                              textToHighlight={imgEntry?.data?.impression}
                              searchWords={imgEntry?.data?.selectedText}
                              highlightStyle={{
                                backgroundColor: 'transparent',
                                color: 'orange',
                                fontWeight: 'bold',
                              }}
                            />
                          </div>
                        </div>
                        {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                      </div>

                      {/* <CTable>
                                <CTableHead>
                                    <CTableRow>
                                        <CTableHeaderCell>Imaging Type</CTableHeaderCell>
                                        <CTableHeaderCell>Impression</CTableHeaderCell>

                                    </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                    <CTableRow>
                                        <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
                                        <CTableDataCell style={{ width: "60%" }} className='' valign="" >
                                            <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                        </CTableDataCell>


                                    </CTableRow>
                                </CTableBody>
                            </CTable> */}
                    </CCardBody>
                  </div>
                )
              })}
          </div>
        {!loading && imagingList.length === 0 || 
        [...imagingList]
              .filter((imgEntry) => !noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))?.length === 0
        && <div className="text-center my-3">No Old Imaging Available</div>}
        </div>


        <CModal backdrop="static" size="lg" scrollable visible={modalVisible} onClose={() => setModalVisible(false)}>
          <CModalHeader onClose={() => setModalVisible(false)}>
            <CModalTitle>Patient Imaging</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="mb-3">
              <CFormLabel>Date</CFormLabel>
              {/* <CFormInput
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        /> */}
              <span className="d-block ml-2">
                <CustomDatePickingFormat value={date} onChange={(e) => setDate(e)} format="mm-dd-yyyy" />
              </span>
            </div>
            <div className="mb-3">
              <CFormLabel>Imaging</CFormLabel>
              <CFormSelect value={imagingType} onChange={handleSelectImaging}>
                <option value="">Select Imaging Type</option>
                {imagingTypeList.map((type, index) => (
                  <option key={index} value={type.ID}>
                    {type.Name}
                  </option>
                ))}
              </CFormSelect>
            </div>
            {showComment && (
              <div className="mb-3">
                <CFormLabel>Comment</CFormLabel>
                <Graytextarea rows={4} value={comment} onChange={(e) => setComment(e.target.value)} />
              </div>
            )}
            <div className="mb-3">
              <CFormLabel>Impression</CFormLabel>
              <Graytextarea rows={4} value={impression} onChange={(e) => setImpression(e.target.value)} />
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setModalVisible(false)}>
              Cancel
            </CButton>
            <CButton color="primary" variant="outline" onClick={handleSaveImaging}>
              {isLoading ? (
                <>
                  <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                  Loading...
                </>
              ) : editImagingId !== null ? (
                'Update Imaging'
              ) : (
                'Save Imaging'
              )}
            </CButton>
          </CModalFooter>
        </CModal>
      </>
    )
};

export default ProvuderPatientImaging;
